module.exports = __webpack_public_path__ + "static/media/export.906e4514.svg";